// import { createContext, useContext, useState, useEffect } from "react";
// import { Link, useParams } from "react-router-dom";
// import {
//   daysIsPost,
//   daysIsNotPost,
//   calendarYears,
//   easterDays,
//   idsMonths,
//   manualDateEaster,
//   monthSerb,
// } from "../components/Calendar/calendar-data/calendar-data";
// // import data from "../all__news";
// import data2 from "../all__news.json";
// import data1 from "../allData.json";
// import { renderTitleSection } from "./utility";
// import news2 from "../components/Calendar/calendar-data/all__news4.json";

// const IdContext = createContext();

// const data = data1.concat(data2);
// export const useIdContext = () => useContext(IdContext);

// export const IdProvider = ({ children }) => {
//   const currentDate = new Date();
//   const currentYear = currentDate.getFullYear();
//   const { slug, id } = useParams();

//   const isYear = Number(slug) || currentDate.getFullYear();
//   const isMonth = id ? monthSerb.indexOf(id) : currentDate.getMonth();
//   const [isEasterDay, setIsEasterDay] = useState("");

//   useEffect(() => {
//     setHolidays(filterHolidays);
//   }, [isYear, isMonth, slug, id]);

//   let easter = isYear - 2020;
//   let easterDay = new Date(`${isYear}-${manualDateEaster[easter]}`);
//   const easterDate = new Date(easterDay);
//   const endEasterDate = new Date(easterDate);
//   endEasterDate.setDate(easterDate.getDate() - 1);

//   const startEasterDate = new Date(easterDate);
//   startEasterDate.setDate(easterDate.getDate() - 49);

//   const endBelaNedelja = new Date(easterDate);
//   endBelaNedelja.setDate(easterDate.getDate() + 7);

//   const startPetrovskiPost = new Date(easterDate);
//   startPetrovskiPost.setDate(easterDate.getDate() + 57);

//   const endPetrovskiPost = new Date(isYear, 6, 12);

//   const startGospojinskiPost = new Date(isYear, 7, 14);
//   const endGospojinskiPost = new Date(isYear, 7, 27);

//   const setPostDays = (dateInfo, diffInDays) => {
//     // console.log("ITEM calendar", dateInfo.date);
//     let setDateFromDateInfo = new Date(dateInfo);
//     //start - Bozic i Bozicni post
//     let bozicniPostStart = new Date(isYear, 10, 28);
//     let bozicniPostEnd = new Date(isYear, 0, 6);
//     let vikendPosleBozica = new Date(isYear, 0, 17);
//     let notPost = daysIsNotPost.map((item) =>
//       new Date(isYear, item[0], item[1]).setHours(0, 0, 0, 0)
//     );
//     let isPost = daysIsPost.map((item) =>
//       new Date(isYear, item[0], item[1]).setHours(0, 0, 0, 0)
//     );
//     let setDateDay = setDateFromDateInfo.getDay();
//     if (setDateFromDateInfo >= bozicniPostStart) {
//       return "post";
//     } else if (setDateFromDateInfo <= bozicniPostEnd) {
//       return "post";
//     } else if (
//       //Uskrsnji post
//       setDateFromDateInfo <= endEasterDate &&
//       startEasterDate <= setDateFromDateInfo
//     ) {
//       return "post";
//     } else if (
//       //Petrovski post
//       setDateFromDateInfo < endPetrovskiPost &&
//       startPetrovskiPost <= setDateFromDateInfo
//     ) {
//       return "post";
//     } else if (
//       //Gospojinski post
//       setDateFromDateInfo <= endGospojinskiPost &&
//       startGospojinskiPost <= setDateFromDateInfo
//     ) {
//       return "post";
//     } else if (setDateFromDateInfo <= vikendPosleBozica) {
//       //Bela nedelja
//       return "";
//     } else if (
//       setDateFromDateInfo > easterDate &&
//       setDateFromDateInfo <= endBelaNedelja
//     ) {
//       return "";
//     } else if (setDateDay === 3 || setDateDay === 5) {
//       if (!notPost.includes(setDateFromDateInfo.setHours(0, 0, 0, 0))) {
//         return "post";
//       }
//     } else if (isPost.includes(setDateFromDateInfo.setHours(0, 0, 0, 0))) {
//       return "post";
//     } else {
//       return "";
//     }
//   };

//   const [holidays, setHolidays] = useState(filterHolidays);

//   function filterHolidays() {
//     let yearIndex = calendarYears[0].item_list.findIndex(
//       (item) => item.title == isYear
//     );
//     //zadusnice-------------------------------------------------------------
//     let zadusniceIndex = calendarYears[0].item_list[
//       yearIndex
//     ].zadusnice.findIndex((item) => item[0] == isMonth);

//     let zadusniceDate = calendarYears[0].item_list[yearIndex].zadusnice.find(
//       (item) => item[0] === isMonth
//     );
//     //end---------------------------------------------------------------------
//     //uskrs-------------------------------------------------------------------
//     let easter = isYear - 2020;
//     let monthData = JSON.parse(JSON.stringify(news2));
//     // console.log("MonthData", isMonth);

//     let setHol = monthData.slice(idsMonths[isMonth][0], idsMonths[isMonth][1]);
//     // console.log("setHol", setHol);
//     //end---------------------------------------------------------------------
//     let setHolTest = setHol.map((item, index) => {
//       item.title = Array.isArray(item.title)
//         ? item.title.map((item) => item)
//         : [item.title];

//       let setDate = new Date(isYear, isMonth, index);
//       let currentDay2 = setDate.getDay();

//       if (zadusniceDate && zadusniceDate[1] === index + 1) {
//         item.title = (
//           <>
//             {Array.isArray(item.title)
//               ? item.title.map((el, index) => (
//                   <>
//                     <h2>{el}</h2>
//                     {index !== item.title.length - 1 ? "; " : ""}
//                   </>
//                 ))
//               : item.title}{" "}
//             -{" "}
//             <Link to="/zadusnice/" className="zadusniceStrong">
//               Zadušnice
//             </Link>{" "}
//             <strong style={{ color: "black", fontWeight: 600 }}>
//               {calendarYears[0].zadusnice[zadusniceIndex]}
//             </strong>
//           </>
//         );
//       }

//       let date1 = new Date(isYear, isMonth, index + 1);
//       item.date = date1;
//       let easterDay = new Date(`${isYear}-${manualDateEaster[easter]}`);
//       setIsEasterDay(easterDay);
//       let diffInDays = (easterDay - date1) / (1000 * 60 * 60 * 24); // Razlika u danima
//       if (diffInDays >= -2 && diffInDays <= 6) {
//         item.title = renderTitleSection({
//           extraLabel: easterDays[easterDays.length - 3 - diffInDays],
//           strongClass:
//             currentDay2 === 3 || currentDay2 === 5
//               ? "blackStrong"
//               : diffInDays < 4
//               ? "redStrong"
//               : "blackStrong",
//         });
//       } else if (diffInDays == -24) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Prepolovljenje)",
//         });
//       } else if (diffInDays == -31) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Odanije Prepolovljenja)",
//         });
//       } else if (diffInDays == -38) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Odanije Vaskrsa)",
//         });
//       } else if (diffInDays == -39) {
//         item.title = renderTitleSection({
//           mainTitle: false,
//           strongClass: "redStrong",
//           extraLabel: "Vaznesenje Gospodnje – Spasovdan",
//         });
//       } else if (diffInDays == -47) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Odanije Vaznesenja)",
//         });
//       } else if (diffInDays == -49) {
//         item.title = renderTitleSection({
//           mainTitle: false,
//           strongClass: "redStrong",
//           extraLabel: "Silazak Svetog Duha na apostole - Pedesetnica - Trojice",
//         });
//       } else if (diffInDays == -50) {
//         item.title = renderTitleSection({
//           mainTitle: false,
//           strongClass: "redStrong",
//           extraLabel: "Duhovski ponedeljak",
//         });
//       } else if (diffInDays == -51) {
//         item.title = renderTitleSection({
//           mainTitle: false,
//           strongClass: "redStrong",
//           extraLabel: "Duhovski utorak",
//         });
//       } else if (diffInDays == -55) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Odanije Pedesetnice)",
//         });
//       } else if (diffInDays == -56) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Petrovske poklade)",
//         });
//       } else if (diffInDays == -57) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Početak Petrovskog posta)",
//         });
//       } else if (currentDay2 === 5 && diffInDays > 5 && diffInDays < 10) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "Lazareva subota (Vrbica)",
//           separatorSymbol: "- ",
//           slavaSymbol: true,
//         });
//       } else if (currentDay2 == 6 && diffInDays > 5 && diffInDays < 10) {
//         item.title = renderTitleSection({
//           mainTitle: false,
//           extraLabel: "Ulazak Gospoda Isusa Hrista u Jerusalim – Cveti",
//           slavaSymbol: true,
//           strongClass: "redStrong",
//         });
//       } else if (currentDay2 === 2 && diffInDays > 15 && diffInDays < 20) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Prvo bdenije)",
//         });
//       } else if (currentDay2 === 4 && diffInDays > 15 && diffInDays < 20) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "(Drugo bdenije)",
//         });
//       } else if (currentDay2 === 0 && diffInDays > -10 && diffInDays < 0) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "Pobusani ponedeljak",
//           separatorSymbol: "- ",
//         });
//       } else if (currentDay2 === 4 && diffInDays > -8 && diffInDays < 2) {
//         item.title = renderTitleSection({
//           mainTitle: item.title,
//           extraLabel: "Istočni petak",
//           separatorSymbol: "; ",
//         });
//       }
//       item.post = setPostDays(item.date, diffInDays);
//       return item;
//     });
//     return setHolTest;
//   }

//   return (
//     <IdContext.Provider
//       value={{
//         data,
//         id,
//         slug,
//         currentDate,
//         currentYear,
//         easterDay,
//         isYear,
//         isMonth,
//         holidays,
//         isEasterDay,
//       }}
//     >
//       {children}
//     </IdContext.Provider>
//   );
// };

// {
//   "date": [1, 27],
//   "title": "Prepodobni Avksentije i Sveti Kiril slovenski – Ćirilovdan (ako pada u Veliki post, pomera se na nedelju siropusnu)"
// },
import React, { useMemo } from "react";
import { createContext, useContext } from "react";
import { Link, useParams } from "react-router-dom";
// import data from "../all__news";
import {
  calendarYears,
  daysIsNotPost,
  daysIsPost,
  easterDays,
  idsMonths,
  manualDateEaster,
  monthSerb,
  days,
} from "../components/Calendar/calendar-data/calendar-data";
import { renderTitleSection, toMidnightTs } from "./utility";
import news2 from "../components/Calendar/calendar-data/all__news4.json";
const IdContext = createContext();

export const useIdContext = () => useContext(IdContext);

export const IdProvider = ({ children }) => {
  const currentDate = new Date();
  let currentDay = currentDate.getDate();
  let dayName = days[currentDate.getDay()];
  const monthName = monthSerb[currentDate.getMonth()];
  let todayHoliday;

  // // --- AUTO RELOAD KADA SE PROMENI DAN ---
  // React.useEffect(() => {
  //   const today = new Date().toISOString().slice(0, 10);

  //   // Inicijalno postavljanje ako ne postoji
  //   const last = localStorage.getItem("lastReloadDay");
  //   if (!last) {
  //     localStorage.setItem("lastReloadDay", today);
  //   }

  //   const check = () => {
  //     if (document.visibilityState !== "visible") return;

  //     const now = new Date().toISOString().slice(0, 10);
  //     const stored = localStorage.getItem("lastReloadDay");

  //     if (now !== stored) {
  //       localStorage.setItem("lastReloadDay", now);
  //       window.location.reload();
  //     }
  //   };

  //   document.addEventListener("visibilitychange", check);
  //   const interval = setInterval(check, 30000);

  //   return () => {
  //     document.removeEventListener("visibilitychange", check);
  //     clearInterval(interval);
  //   };
  // }, []);
  // // --- END AUTO RELOAD ---

  const currentYear = currentDate.getFullYear();

  const { slug, id } = useParams();
  const isYear = Number(slug) || currentDate.getFullYear();
  let yearIndex = calendarYears[0].item_list.findIndex(
    (item) => item.title == isYear
  );
  const isMonth = id ? monthSerb.indexOf(id) : currentDate.getMonth();

  const easterDay = useMemo(
    () => new Date(`${isYear}-${manualDateEaster[isYear - 2020]}`),
    [isYear]
  );
   const easterDate = new Date(easterDay);
  const endEasterDate = new Date(easterDate);
  endEasterDate.setDate(easterDate.getDate() - 1);
  const startEasterDate = new Date(easterDate);
  startEasterDate.setDate(easterDate.getDate() - 48);

  // helper koji vrati timestamp u ponoć
  const toTs = (y, m, d) => new Date(y, m, d).setHours(0, 0, 0, 0);

  const postLookup = useMemo(() => {
    const bozicniPostStartTs = toTs(isYear, 10, 28);
    const bozicniPostEndTs = toTs(isYear, 0, 6);
    const vikendPosleBozicaTs = toTs(isYear, 0, 17);

    const easterTs = toTs(
      easterDay.getFullYear(),
      easterDay.getMonth(),
      easterDay.getDate()
    );
    const startEasterTs = toTs(
      easterDay.getFullYear(),
      easterDay.getMonth(),
      easterDay.getDate() - 48
    );
    const endEasterTs = toTs(
      easterDay.getFullYear(),
      easterDay.getMonth(),
      easterDay.getDate() - 1
    );

    const notPostSet = new Set(
      daysIsNotPost.map(([m, d]) => toTs(isYear, m, d))
    );
    const isPostSet = new Set(daysIsPost.map(([m, d]) => toTs(isYear, m, d)));

    return {
      bozicniPostStartTs,
      bozicniPostEndTs,
      vikendPosleBozicaTs,
      startEasterTs,
      endEasterTs,
      easterTs,
      notPostSet,
      isPostSet,
    };
  }, [isYear, easterDay]);

  const setPostDays = (dateInfo) => {
    const ts =
      typeof dateInfo === "number"
        ? dateInfo
        : new Date(dateInfo).setHours(0, 0, 0, 0);

    const {
      bozicniPostStartTs,
      bozicniPostEndTs,
      startEasterTs,
      endEasterTs,
      notPostSet,
      isPostSet,
    } = postLookup;

    if (ts >= bozicniPostStartTs || ts <= bozicniPostEndTs) return "post";
    if (ts >= startEasterTs && ts <= endEasterTs) return "post";

    const day = new Date(ts).getDay();
    if ((day === 3 || day === 5) && !notPostSet.has(ts)) return "post";
    if (isPostSet.has(ts)) return "post";

    return "";
  };
  const getTargetSundayBeforeChristmas = (year) => {
    // broj nedelja (Sunday) u periodu 1–6. januar naredne godine
    const nextYear = isYear + 1;
    let sundayCount = 0;

    for (let d = 1; d <= 6; d++) {
      const date = new Date(nextYear, 0, d);
      if (date.getDay() === 0) sundayCount++;
    }

    // poslednja i pretposlednja nedelja u decembru tekuće godine
    const lastSundayOfDecember = (() => {
      const d = new Date(isYear, 11, 31);
      d.setDate(d.getDate() - d.getDay()); // vraća na nedelju
      d.setHours(0, 0, 0, 0);
      return d;
    })();

    if (sundayCount === 1) {
      return lastSundayOfDecember;
    }

    // sundayCount === 0
    const secondLastSunday = new Date(lastSundayOfDecember);
    secondLastSunday.setDate(lastSundayOfDecember.getDate() - 7);
    return secondLastSunday;
  };
  const getSundaysBeforeChristmas = (year) => {
    const result = [];
    const result1 = [];
    const result2 = [];
    const nextYear = isYear + 1;

    // 1) Nedelja u periodu 1–6. januar tekuce godine
    for (let d = 1; d <= 6; d++) {
      const date = new Date(isYear, 0, d);
      if (date.getDay() === 0) {
        date.setHours(0, 0, 0, 0);
        result1.push(date);
        break; // može biti samo jedna
      }
    }

    // 1) Nedelja u periodu 1–6. januar naredne godine
    for (let d = 1; d <= 6; d++) {
      const date = new Date(nextYear, 0, d);
      if (date.getDay() === 0) {
        date.setHours(0, 0, 0, 0);
        result2.push(date);
        break; // može biti samo jedna
      }
    }

    // 2) Poslednja nedelja u decembru tekuće godine
    const lastSunday = new Date(isYear, 11, 31);
    lastSunday.setDate(lastSunday.getDate() - lastSunday.getDay());
    lastSunday.setHours(0, 0, 0, 0);

    //ako postoji januarska u tekucoj → dodaj
    if (result1.length !== 0) {
      result.push(result1[0]);
      return result;
    }

    // ako ne postoji januarska u narednoj → dodaj poslednju
    if (result2.length === 0) {
      result.push(lastSunday);
      return result;
    }
    return result;
  };

  const holidays = useMemo(() => filterHolidays(), [isYear, isMonth]);

  function filterHolidays() {
    const secondSundayBeforeChristmas = getTargetSundayBeforeChristmas(isYear);
    const sundaysBeforeChristmas = getSundaysBeforeChristmas(isYear);

    let yearIndex = calendarYears[0].item_list.findIndex(
      (item) => item.title == isYear
    );
    //zadusnice-------------------------------------------------------------
    let zadusniceIndex = calendarYears[0].item_list[
      yearIndex
    ].tableNum.findIndex((item) => item[0] == isMonth);

    let zadusniceDate = calendarYears[0].item_list[yearIndex].tableNum.find(
      (item) => item[0] === isMonth
    );
    //end---------------------------------------------------------------------

    //uskrs-------------------------------------------------------------------
    let setHol = news2
      .slice(idsMonths[isMonth][0], idsMonths[isMonth][1])
      .map((item) => ({ ...item })); // shallow copy po itemu
    //end---------------------------------------------------------------------

    // Dodavanje 29. februara za prestupnu godinu
    const isLeap =
      (isYear % 4 === 0 && isYear % 100 !== 0) || isYear % 400 === 0;

    if (isMonth === 1 && isLeap) {
      // Ubacujemo na poziciju 28 (29. dan)
      setHol.splice(28, 0, {
        title: ["Sveti mučenici Pamfil", "Porfirije i drugih deset mučenika"],
      });
    }

    let setHolTest = setHol.map((item, index) => {
      item.title = Array.isArray(item.title)
        ? item.title.map((item) => item)
        : [item.title];
      let date1 = new Date(isYear, isMonth, index + 1);
      item.date = date1;
      let currentDay2 = date1.getDay();
      let diffInDays = Math.round((easterDay - date1) / (1000 * 60 * 60 * 24)); // Razlika u danima

      if (zadusniceDate && zadusniceDate[1] === index + 1) {
        item.mainTitle = item.title;
        item.extraLabel = `Zadušnice ${calendarYears[0].zadusnice[zadusniceIndex]}`;
        item.extraLabelLink = "/zadusnice/";
        item.strongClass = "zadusniceStrong";
        item.separatorSymbol = " - ";
      }

      if (diffInDays >= -2 && diffInDays <= 6) {
        item.title = easterDays[easterDays.length - 3 - diffInDays];
        item.strongClass =
          currentDay2 === 3 || currentDay2 === 5
            ? "blackStrong"
            : diffInDays < 4
            ? "redStrong"
            : "blackStrong";
      } else if (diffInDays == -24) {
        item.mainTitle = item.title;
        item.extraLabel = "(Prepolovljenje)";
      } else if (diffInDays == -31) {
        item.mainTitle = item.title;
        item.extraLabel = "(Odanije Prepolovljenja)";
      } else if (diffInDays == -38) {
        item.mainTitle = item.title;
        item.extraLabel = "(Odanije Vaskrsa)";
      } else if (diffInDays == -39) {
        item.mainTitle = false;
        item.strongClass = "redStrong";
        item.extraLabel = "Vaznesenje Gospodnje - Spasovdan";
        item.separatorSymbol = "; ";
      } else if (diffInDays == -47) {
        item.mainTitle = item.title;
        item.extraLabel = "(Odanije Vaznesenja)";
      } else if (diffInDays == -49) {
        item.mainTitle = false;
        item.strongClass = "redStrong";
        item.extraLabel =
          "Silazak Svetog Duha na apostole - Pedesetnica - Trojice";
      } else if (diffInDays == -50) {
        item.mainTitle = false;
        item.strongClass = "redStrong";
        item.extraLabel = "Duhovski ponedeljak";
        item.separatorSymbol = "; ";
      } else if (diffInDays == -51) {
        item.mainTitle = false;
        item.strongClass = "redStrong";
        item.extraLabel = "Duhovski utorak";
        item.separatorSymbol = "; ";
      } else if (diffInDays == -55) {
        item.mainTitle = item.title;
        item.extraLabel = "(Odanije Pedesetnice)";
      } else if (diffInDays == -56) {
        item.mainTitle = item.title;
        item.extraLabel = "(Petrovske poklade)";
      } else if (diffInDays == -57) {
        item.mainTitle = item.title;
        item.extraLabel = "(Početak Petrovskog posta)";
      } else if (diffInDays == 48) {
        item.mainTitle = item.title;
        item.extraLabel = "(Početak Vaskršnjeg posta)";
      } else if (currentDay2 === 6 && diffInDays > 5 && diffInDays < 10) {
        item.mainTitle = item.title;
        item.extraLabel = "Lazareva subota (Vrbica)";
        item.separatorSymbol = "- ";
        item.slava = true;
      } else if (currentDay2 == 0 && diffInDays > 5 && diffInDays < 10) {
        item.title = "Ulazak Gospoda Isusa Hrista u Jerusalim - Cveti";
        item.slava = true;
        item.mainClass = "mainRedStrong";
        item.strongClass = "redStrong";
      } else if (currentDay2 === 3 && diffInDays > 15 && diffInDays < 20) {
        item.mainTitle = item.title;
        item.extraLabel = "(Prvo bdenije)";
      } else if (currentDay2 === 5 && diffInDays > 15 && diffInDays < 20) {
        item.mainTitle = item.title;
        item.extraLabel = "(Drugo bdenije)";
      } else if (currentDay2 === 1 && diffInDays > -10 && diffInDays < 0) {
        item.mainTitle = item.title;
        item.extraLabel = "Pobusani ponedeljak";
        item.separatorSymbol = "; ";
      } else if (currentDay2 === 5 && diffInDays > -8 && diffInDays < 2) {
        item.mainTitle = item.title;
        item.extraLabel = "Istočni petak";
        item.separatorSymbol = "; ";
      } else if (currentDay2 === 6 && diffInDays < 50 && diffInDays > 40) {
        item.mainTitle = item.title;
        item.extraLabel = "Teodorova subota";
        item.separatorSymbol = "; ";
      } else if (currentDay2 === 0 && diffInDays < 60 && diffInDays > 50) {
        item.mainTitle = item.title;
        item.extraLabel = "(Mesne poklade)";
        item.strongClass = "blackStrong";
        item.separatorSymbol = " ";
      } else if (currentDay2 === 0 && diffInDays < 50 && diffInDays > 45) {
        item.mainTitle = item.title;
        item.extraLabel = "(Bele poklade)";
        item.strongClass = "blackStrong";
        item.separatorSymbol = " ";
      }

      //Materice, Oci
      if (
        toMidnightTs(item.date) === toMidnightTs(secondSundayBeforeChristmas)
      ) {
        item.mainTitle = item.title;
        item.extraLabel = "Materice";
        item.strongClass = "blackStrong";
        item.separatorSymbol = " - ";
      }
      // Nedelja pred Božić
      if (
        sundaysBeforeChristmas.some((d) => d.getTime() === item.date.getTime())
      ) {
        item.mainTitle = item.title;
        item.extraLabel = "Oci (Paterice)";
        item.strongClass = "blackStrong";
        item.separatorSymbol = " - ";
      }
      item.post = setPostDays(item.date.getTime());
      if (currentDate.setHours(0, 0, 0, 0) === item.date.setHours(0, 0, 0, 0)) {
        item.today = " today";
        todayHoliday = item;
      }
      return item;
    });

    return setHolTest;
  }
  return (
    <IdContext.Provider
      value={{
        dayName,
        id,
        slug,
        currentDate,
        currentDay,
        monthName,
        currentYear,
        easterDay,
        isYear,
        yearIndex,
        isMonth,
        holidays,
        todayHoliday,
      }}
    >
      {children}
    </IdContext.Provider>
  );
};
